// Map modes
export const MAP_MODES = {
  MAPPA: 'mappa',
  FLUSSO: 'flusso',
  NUVOLA: 'nuvola',
};

// Network view categories
export const NETWORK_CATEGORIES = {
  VELOCITA: 'velocita',
  FLOW: 'flow',
  TRAVEL_TIME: 'traveltime',
};

// Sider sections
export const SIDER_SECTIONS = {
  INFO: 'info',
  PROPRIETA: 'proprieta',
  VELOCITA: 'velocita',
  FLOW: 'flow',
  TRAVEL_TIME: 'traveltime',
  RUMOROSITA: 'rumorosita',
  VIBRAZIONE: 'vibrazione',
};

// Feature modules
export const FEATURE_MODULES = {
  FCD_NETWORK: 'fcd',
  SIMFIX_AREAS: 'simfix',
  PREDICT: 'predict',
  TL_GREEN_WAVE: 'tl_green_wave',
  SIGNALFIX: 'signalfix',
  SEMAFIX: 'semafix',
  OD_ANALYSIS: 'od_analysis',
};

// Map default settings
export const MAP_DEFAULTS = {
  CENTER: [44.4056, 8.9463], // fallback until client network bounds are known
  ZOOM: 13,
  MAX_ZOOM: 19,
  MIN_ZOOM: 3,
};

// Timeouts
export const TIMEOUTS = {
  MAP_RESIZE: 50,
  MAP_RESIZE_LONG: 100,
  MODE_SWITCH: 400,
};
